/* global u, Drupal, objectFitImages */
/* eslint complexity: [1, 50] */
import initAccordian from '../_patterns/02-molecules/accordion-item/accordion-item';
import initFilterBar from '../_patterns/02-molecules/filter-bar/filter-bar';
import initPoll from '../_patterns/02-molecules/poll/poll';
import initNav from '../_patterns/03a-organisms-main-site/header/site-header';
import initNavScroll from '../_patterns/04-templates/page';
import initCurtainAnim from '../_patterns/04-templates/page-curtain';
import initExPage from '../_patterns/05-pages/exhibitions-landing';
import initBackToTop from '../_patterns/01-atoms/06-buttons/back-to-top';
import ScrollMachine from '../_patterns/00-base/global/utils/scroll-machine';
import initDropdowns from '../_patterns/01-atoms/05-forms/dropdown/dropdown';
import initSubmitButtons from '../_patterns/01-atoms/06-buttons/submit';
import is_mobile from '../_patterns/00-base/global/utils/ismobile';
import initBookingForm from '../_patterns/05-pages/book-your-school-page';
import initDateDropdowns from '../_patterns/02-molecules/form/date-dropdown/date-dropdown';
import initDisclosure from '../_patterns/02-molecules/disclosure/disclosure-button';
import initInpageNav from '../_patterns/02-molecules/inpage-nav/inpage-nav';
import initShareWidget from '../_patterns/01-atoms/11-icons/icon';
import initBannerHide from '../_patterns/02-molecules/beta-banner/beta-banner';
import initCookieBanner from '../_patterns/02-molecules/cookie-banner/cookie-banner';
import DocumentScroller from '../_patterns/00-base/global/utils/document-scroller';
import isMobileSafari from '../_patterns/00-base/global/utils/is-mobile-safari';
import { fixVideojs } from '../_patterns/01-atoms/08-video/video';
import initPrintButtons from '../_patterns/01-atoms/06-buttons/print-button';
import initFloatOrphans from '../_patterns/01-atoms/04-images/00-image/wysiwyg-image';
import initSocialComments from '../_patterns/03a-organisms-main-site/items-in-row/social-comments/social-comments.js';
import insertCustomMap from '../_patterns/01-atoms/google-map/custom-google-map.js';
import ScrollUpdateChecker from '../_patterns/00-base/global/utils/scroll-update-checker.js';
import HeaderHeightCalculator from '../_patterns/00-base/global/utils/header-height-calculator';
import initCameraTagForm from '../_patterns/02-molecules/cameratag/cameratag';
import checkAjaxResponse from '../_patterns/03a-organisms-main-site/form/check-ajax-response';
import clearAnnouncements  from "../_patterns/00-base/global/utils/clear-announcements.js";


if (window.isCmhrModernJs) {

  performance.mark('mn-start');

  /**
   * Initiates page functionality
   */
  

  const scrollUpdateChecker = new ScrollUpdateChecker();
  scrollUpdateChecker.setScrollUpdateAllowed(false);

  const headerHeightCalculator = new HeaderHeightCalculator();

  const documentScroller = new DocumentScroller(scrollUpdateChecker, headerHeightCalculator);
  documentScroller.subscribeToPopState();

  function scrollToElementDefaultHeaderCalculator(link, position, offset) {
    return documentScroller.scrollToElement(link, position, offset);
  }

  let initMain = () => {

    performance.mark('dcl-start');
    const isDrupal = typeof Drupal !== "undefined";

    const scroll_machine = new ScrollMachine(1000, scrollUpdateChecker);

    const mSafari = isMobileSafari();
    const main_container = u('main');
    const skip_btn = document.querySelector('.js-button--skip');

    const add_to_cal_btn = document.querySelector('.js-add-to-cal');

    if (add_to_cal_btn) {
      add_to_cal_btn.addEventListener('click', e => {
        e.preventDefault();
        window.location = e.currentTarget.dataset.download;
      });
    }

    /** If present, remove the service worker that was causing Google Analytics double-firing.
     * TEMPORARY CODE.  Remove when service workers are re-implemented.
     */

    if (navigator && navigator.serviceWorker && navigator.serviceWorker.getRegistrations) {

      //Source: https://love2dev.com/blog/how-to-uninstall-a-service-worker/
      navigator.serviceWorker.getRegistrations().then(
        function (registrations) {
          for (const registration of registrations) {
            registration.unregister();

          }
        });
    }


    document.body.addEventListener('click', e => {
      if (e.target.nodeName === 'A' && e.target.classList.contains('js-edit-error-link')) {
        const href = e.target.getAttribute('href');
        const link_target = href ? document.querySelector(href) : null;

        e.preventDefault();

        if (link_target) {
          const focusable = link_target.querySelector('input, textarea, [tabindex="0"]');

          if (focusable) {
            focusable.focus();
          }

          scrollToElementDefaultHeaderCalculator(link_target);
        }
      }
    });

    if (mSafari) {
      document.body.classList.add('ios-safari');
    }

    if (is_mobile) {
      document.body.classList.add('mobile');
    } else {
      document.body.classList.add('desktop');
    }

    
      //initDropdowns();      // Initializes dropdowns
      initDateDropdowns();
      initExPage();
      initSubmitButtons();
      initFilterBar();
      setProgressMessages();

      if (isDrupal) {
        initDrupal();
      }

    const banner = initBannerHide();
    initBackToTop(scrollUpdateChecker);
    initPoll();
    initAccordian();
    initNav(banner);
    fixVideojs();
    insertCustomMap(documentScroller);
    initCameraTagForm();


    if (u('.js-cookie-banner').length > 0) {
      initCookieBanner();
    }


    initInpageNav(documentScroller);
    

    initShareWidget();

    if (main_container.hasClass('book-your-school-template')) {
      initBookingForm(documentScroller);
    }


    initDisclosure();

    window.initDisclosure = initDisclosure;


    initNavScroll(scroll_machine);



    const curtain = initCurtainAnim(scroll_machine, documentScroller);
    if (skip_btn) {
      const main_content = document.querySelector('main h1');
      if (main_content) {
        skip_btn.addEventListener('click', e => {
          e.preventDefault();
          main_content.focus();
          if (curtain) {
            curtain.raise();
          } else {
            window.scrollTo(0, 0);
          }
        });
      }
    }


    initPrintButtons();
    initFloatOrphans();
    initSocialComments();

    performance.mark('dcl-end');
    performance.measure('dcl', 'dcl-start', 'dcl-end');
  };

  if (/complete|interactive/.test(document.readyState)) {
    initMain();
  } else {
    document.addEventListener('DOMContentLoaded', initMain);
  }

  function setProgressMessages(context) {
    const noMessageButtons = Object.values(drupalSettings.ajax).filter(btn => !btn.progress.message);
    noMessageButtons.forEach((btnDetails) => {
      btnDetails.progress.message = Drupal.t('ajax_loading.loading_form');
    })
  }

  function initDrupal() {
  // Below is Drupal-only code.
  
     performance.mark("dr-start");
    (function (Drupal) {
      Drupal.behaviors.initAjaxedContent = {
        attach: function (context) {
          initDropdowns(context);      // Initializes dropdowns
          initDateDropdowns(context);
          initExPage(context);
          initSubmitButtons(null, context);
          initFilterBar(context);
          checkAjaxResponse(context);
          setProgressMessages(context);
        }
      };

      function getInertElements() {
        return Array.from(document.querySelectorAll("#splash-screen, main, footer"));
      }

      function getBackupProgressMessage() {
        const loadingEl = document.querySelector(
          ".js-ajax-status[data-loading]"
        );
        if (loadingEl) {
          return loadingEl.dataset.loading;
        }
      }

      Drupal.Ajax.prototype.disableScreen = function() {
        clearAnnouncements();
        this.progress.inertElements = getInertElements();
        this.progress.inertElements.forEach((el) =>
          el.setAttribute("inert", "inert")
        );
      }

      Drupal.Ajax.prototype.enableScreen = function() {
        (this?.progress?.inertElements ?? []).forEach((el) => el.removeAttribute('inert'));
      }
      /* global jQuery */
      Drupal.Ajax.prototype.setProgressIndicatorFullscreen = function () {
        const messageText = this.progress.message ?? getBackupProgressMessage();
        const messageHtml = messageText ? `<p class="throbber-message">${messageText}</p>` : '';

        this.progress.element = document.createElement('div');
        this.progress.element.classList.add('ajax-progress', 'ajax-progress-fullscreen');
        const innerElement = document.createElement('div');
        innerElement.classList.add('throbber-inner');
        innerElement.setAttribute('tabindex', -1);
        innerElement.insertAdjacentHTML( 'beforeend', `<div class="throbber"></div>${messageHtml}` );
        this.progress.element.append(innerElement);
        
        document.body.append(this.progress.element);
        this.progress.element.querySelector('.throbber-inner').focus();
        this.disableScreen();
      };

      const parentSuccess = Drupal.Ajax.prototype.success;
      const parentError = Drupal.Ajax.prototype.error;

      Drupal.Ajax.prototype.success = function(response, status) {
        this.enableScreen();
        const _self = this;
        parentSuccess.call(_self, response, status);
      }

      Drupal.Ajax.prototype.error = function (req, uri, customMessage) {
        this.enableScreen();
        const _self = this;
        parentError.call(_self, req, uri, customMessage);
      };

      Drupal.behaviors.initAjax = {
        attach: function () {
          // Override drupal webform scroll functionality.
          if (Drupal.AjaxCommands) {

            Drupal.AjaxCommands.prototype.webformScrollTop = function () {

              // If there's messages, scroll to them (whether error or success).
              const messages = document.querySelector('.status-messages');
              if (messages) {
                // Set focus and scroll to them.
                messages.focus();
                setTimeout(() => {
                  scrollToElementDefaultHeaderCalculator(messages);
                }, 100);
              } else {
                const thank_you = document.querySelector('.form-thankyou');

                if (thank_you) {
                  const head_height = document.querySelector('.head-wrapper').getBoundingClientRect().height;
                  scrollToElementDefaultHeaderCalculator(thank_you, 'top', -head_height);
                } else {
                  const form_heading = document.querySelector('.js-form-heading');

                  if (form_heading) {
                    form_heading.focus();
                    scrollToElementDefaultHeaderCalculator(form_heading);
                  }
                }
              }
            };
            //this is for Views - instead of scrolling, take advantage of the fact 
            //that focusing on the heading will automatically scroll.
             Drupal.AjaxCommands.prototype.scrollTop = function () {

             };
          }
        }
      };

      Drupal.behaviors.webformUpdatePageTitle = {
        attach: function (context) {
          if (typeof context === 'undefined') {
            context = document;
          }

          // If we have a form title, append it to the page title.
          const active_step = context.querySelector('.progress-bar-item--active .progress-bar-item__text');

          if (active_step) {

            // Slice off any existing step. Checking for colon delimiter is not rock solid but OK for now.
            // This uses/assumes a page title pattern of "<title>: <step> | <sitename>".

            const step_pos = document.title.lastIndexOf(': ');
            const sitename_pos = document.title.indexOf(' | ');
            const sitename_part = sitename_pos !== -1 ? document.title.substr(sitename_pos) : '';

            // Get the page title - without any form step, or sitename.
            const page_title_part = step_pos !== -1 ? document.title.substr(0, step_pos) : (
              sitename_pos !== -1 ? document.title.substr(0, sitename_pos) : document.title
            );

            // Set new page title to include active step.
            document.title = `${page_title_part}: ${active_step.innerHTML}${sitename_part}`;

            // Also append the step to the h1.
            // If there's a span inside the h1, let's append the step in there.
            let heading = document.querySelector('h1 span');
            if (!heading) {
              heading = document.querySelector('h1');
            }

            if (heading) {
              let heading_text = heading.innerHTML.trim();
              const heading_step_pos = heading_text.indexOf('<span class="form-step visually-hidden">');

              // Strip off existing step if present.
              if (heading_step_pos !== -1) {
                heading_text = heading_text.substr(0, heading_step_pos);
              }

              heading.innerHTML = `${heading_text}<span class="form-step visually-hidden">: ${active_step.innerHTML}</span>`;
            }
          }
        }
      };

    })(Drupal);
  
    performance.mark("dr-end");
    performance.measure('dr', 'dr-start', 'dr-end');
  }
  performance.mark("mn-end");
  performance.measure('mn', 'mn-start', 'mn-end');
}
